import {
  Component,
  Input,
  forwardRef,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'brn-form-select',
  templateUrl: './form-select.component.html',
  styleUrls: ['./form-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormSelectComponent),
      multi: true,
    },
  ],
})
export class FormSelectComponent implements ControlValueAccessor {
  @ViewChild('formSelect')
  formSelect!: ElementRef;

  @ViewChild('formSuggest')
  formSuggest!: ElementRef;

  @Input()
  options!: any[] | null;

  @Input()
  optionLabel!: any;

  @Input()
  optionValue!: any;

  @Input()
  suggest = false;

  @Input()
  style: 'white' | 'grey' = 'grey';

  @Input()
  placeholder = 'Select...';

  @Output()
  valueChange = new EventEmitter<any>();

  @ViewChild('list') listView!: ElementRef;

  showOptionsContainer = false;

  private $value!: any;
  suggestValue!: string;

  get value(): any {
    return this.$value;
  }

  @Input()
  set value(val) {
    this.$value = val;
    this.onChange(this.$value);
  }

  onChange(_: any): any {}

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {}

  select(event: any): void {
    if (this.optionValue) {
      this.value = event[this.optionValue];
      this.valueChange.emit(this.value);
      this.hideOptions();
    } else {
      this.value = event;
      this.valueChange.emit(event);
      this.hideOptions();
    }
  }

  get label(): any {
    if (this.optionLabel && !this.optionValue) {
      return this.value[this.optionLabel];
    } else if (this.optionLabel && this.optionValue) {
      const val = this.options?.filter((item) => {
        return item[this.optionValue] === this.value;
      })[0];
      return val ? val[this.optionLabel] : 'Null';
    }
    return this.value;
  }

  showOptions(): void {
    this.suggestValue = '';
    this.showOptionsContainer = true;

    setTimeout(() => {
      this.formSelect.nativeElement.focus();
      this.formSelect.nativeElement.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
    });
  }

  hideOptions(): void {
    this.showOptionsContainer = false;
  }
}
